// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store'
import { userListReducer, projectListReducer, identityStateReducer } from 'src/app/app-states/reducers/app.reducers';

export interface AppState {
    userListStatus: string,
    projectListStatus: string
}

export const reducers: ActionReducerMap<AppState> = {
    //@ts-ignore
    userListStatus: userListReducer,
    //@ts-ignore
    projectListStatus: projectListReducer
}

export const getAppStateSelector = createFeatureSelector<AppState>('AppState')

export const getUserListSelector = createSelector(getAppStateSelector, (state: AppState) => state.userListStatus)
export const getProjectListSelector = createSelector(getAppStateSelector, (state: AppState) => state.projectListStatus)


export interface IdentityState {
    identity: any,
    status: null | 'not-checked' | 'checked',
    error: boolean,
    idToken: string
}

export interface ApplicationState {
    identityState: IdentityState,
}



export const reducersApplicationState: ActionReducerMap<ApplicationState> = {
    identityState: identityStateReducer
}

export const getApplicationStateSelector = createFeatureSelector<ApplicationState>('ApplicationState')

export const identityState = createSelector(
    getApplicationStateSelector,
    (state) => state.identityState
);